import { inject, Service } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {GoogleService} from './google-service';
import {Observable} from 'rxjs';
import {SureFlowWorkingRatingInput} from '../model/sure-flow-working-rating-input';
import {SureFlowEntityRatingInput} from '../model/sure-flow-entity-rating-input';
import {SureFlowAutoSelectInput} from '../model/sure-flow-auto-select-input';

@Service()
export class SureFlowRatingService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl + 'sureFlow/rating/';

  updateAndSaveWorkingLoopAndUnits(input: SureFlowWorkingRatingInput): Observable<string> {
    const url = this.urlBase + 'working/updateAndSave';
    return this.http.post(url, JSON.stringify(input), {headers: this.getPostHeaders(), responseType: 'text'});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set('Content-Type', 'application/json');
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  autoSelectWorkingUnits(input: SureFlowAutoSelectInput): Observable<string> {
    const url = this.urlBase + 'working/autoSelect';
    return this.http.post(url, JSON.stringify(input), {headers: this.getPostHeaders(), responseType: 'text'});
  }

  updateAndSaveEntityLoopAndUnits(input: SureFlowEntityRatingInput): Observable<string> {
    const url = this.urlBase + 'entity/updateAndSave';
    return this.http.post(url, JSON.stringify(input), {headers: this.getPostHeaders(), responseType: 'text'});
  }

  autoSelectEntityUnits(input: SureFlowAutoSelectInput): Observable<string> {
    const url = this.urlBase + 'entity/autoSelect';
    return this.http.post(url, JSON.stringify(input), {headers: this.getPostHeaders(), responseType: 'text'});
  }

  rearrangeEntityUnits(input: SureFlowEntityRatingInput): Observable<string> {
    const url = this.urlBase + 'entity/rearrange';
    return this.http.post(url, JSON.stringify(input), {headers: this.getPostHeaders(), responseType: 'text'});
  }

}
